<div #mainDiv_ll_model_collateral_edit>


  <div style="position:absolute; " [style.left.px]="bundle.gridX - 10" [style.top.px]="0">

    <div *ngFor="let item of bundle.horzTabs; let i = index"
         style="float:left; white-space:nowrap; cursor:pointer;"
         (click)="selectTab(item.CODE)">

      <!-- Active tab -->
      <div *ngIf="item.CODE === bundle.activeCODE"
           class="wordBtn14_selected"
           style="float: left; padding-right: 30px; box-sizing: border-box;">
        {{ item.LABEL }}
      </div>

      <!-- Inactive tab -->
      <div *ngIf="item.CODE !== bundle.activeCODE"
           class="wordBtn14"
           style="float: left; padding-right: 30px; box-sizing: border-box;">
        {{ item.LABEL }}
      </div>

    </div>

    <span *ngIf="!bundle.saved"
          class="txtRed_14"
          style="float: left; padding-left: 30px; box-sizing: border-box;">
      Key Enter to Save!
    </span>


    <div *ngIf="bundle.activeCODE.toLowerCase() != 'model'"
         class="txtNorm12"
         [style.position]="'absolute'"
         [style.top.px]="bundle.gridY - 20"
         [style.width.px]="bundle.gridW"
         [style.left.px]="bundle.gridX">
      {{bundle.userMessage}}
    </div>
  </div>

  <div *ngIf="bundle.showPayerEdit && bundle.activeCODE.toLowerCase() === 'model'"
       [style.top.px]="bundle.gridY"
       [style.left.px]="bundle.gridX"
       [style.width.px]="bundle.gridW"
       [style.height.px]="bundle.gridH"
       style="position: absolute;">

    <ll-model-collateral-edit-model></ll-model-collateral-edit-model>
  </div>

  <div *ngIf="bundle.activeCODE.toLowerCase() != 'model'" >
    <!-- ==================== GRID ==================== -->
    <div *ngIf="bundle.showPayerEdit"
         [style.top.px]="bundle.gridY"
         [style.left.px]="bundle.gridX"
         style="position: absolute;">
      <jqxGrid #datagrid_ll_model_collateral_edit
               [width]="bundle.gridW"
               [height]="bundle.gridH"
               [sortable]="true"
               [filterable]="true"
               [editable]="true"
               [selectionmode]="'singlerow'"
               [columnsresize]="true"
               (onCellvaluechanged)="onCellvaluechanged($event)"
               (onCellbeginedit)="onCellbeginedit($event)">
      </jqxGrid>
    </div>


    <!-- ==================== SAVE BUTTONS ==================== -->
    <div style="font-size: 12px; font-family: Verdana; margin-top: 30px;">
      <div #beginEdit></div>
      <div #endEdit style="margin-top: 10px;"></div>
    </div>

    <span *ngIf="!bundle.saved"
          class="txtRed_14"
          [style.top.px]="bundle.gridY + bundle.gridH + 10"
          [style.left.px]="bundle.gridX + bundle.gridW - 150"
          style="position: absolute;">
      Key Enter to Save!
    </span>


    <div id=gridTarget
         [style.top.px]="bundle.gridY"
         [style.left.px]="bundle.gridX + (bundle.gridW / 2)"
         style="position: absolute;">
      <jqxPopover #popover_dialog
                  [selector]="'#gridTarget'"
                  [offset]='{ left: 0, top: 300 }'
                  [arrowOffsetValue]="-0"
                  [showArrow]="false"
                  [width]="500"
                  [height]="200"
                  [position]="'top'"
                  [title]="'Apply To'">

        <div style="padding: 10px;">{{bundle.targetElementLabel}} to {{bundle.targetElementValue}}</div>

        <!-- Your dialog content, e.g., choices for 'future'/'all' -->
        <div style="padding: 10px;">
          <div *ngIf="bundle.activeCODE === 'model'" style="padding-bottom: 10px;">Do you want this change applied only to future classes added or all current classes and their payers?</div>
          <div *ngIf="bundle.activeCODE === 'classes'" style="padding-bottom: 10px;">Do you want this change applied only to future payers added to this class or all current and future payers in this class?</div>

          <button class="wordBtn14" (click)="applyChoiceAndSave('future')">Future Only   </button>
          <button class="wordBtn14" (click)="applyChoiceAndSave('all')">All Current and Future   </button>
          <button class="wordBtn14" (click)="closeDialog()">Cancel</button>
        </div>
      </jqxPopover>
    </div>
    <div id=userEntryMsg
         [style.top.px]="bundle.gridY"
         [style.left.px]="bundle.gridX + (bundle.gridW / 2)"
         style="position: absolute;">
      <jqxPopover #popover_userEntryMsg
                  [selector]="'#userEntryMsg'"
                  [offset]='{ left: 0, top: 300 }'
                  [arrowOffsetValue]="-0"
                  [showArrow]="false"
                  [width]="500"
                  [height]="200"
                  [position]="'top'"
                  [title]="'Data Setting Notice'">

        <!-- Your dialog content, e.g., choices for 'future'/'all' -->
        <div style="padding: 10px;">
          <!--<div *ngIf="bundle.activeCODE === 'model'" style="padding-bottom: 10px;">{{bundle.userEntryMessage}}</div>-->
          <div *ngIf="bundle.activeCODE === 'classes'" style="padding-bottom: 10px;">{{bundle.userEntryMessage}}</div>

          <button class="wordBtn14" (click)="applyChoiceAndSave('future')">Future Only</button>
          <button class="wordBtn14" (click)="applyChoiceAndSave('all')">All Current and Future</button>
          <button class="wordBtn14" (click)="closeDialog()">Cancel</button>
        </div>
      </jqxPopover>
    </div>
  </div>

    <div [style.top.px]="bundle.gridY + bundle.gridH + 10"
         [style.left.px]="bundle.gridX"
         style="position: absolute;">

      <div class="wordBtn_11" (click)="exportOnClick()">Download Above List</div>

    </div>

  </div>
